// Local calendar dates: UTC conversion would move the date around midnight.
function isoDate(date) {
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
}

function defaultPeriod(today = new Date()) {
  const start = new Date(today.getFullYear() - 1, today.getMonth(), today.getDate());
  if (start.getMonth() !== today.getMonth()) start.setDate(0);
  return { dataInicio: isoDate(start), dataFim: isoDate(today) };
}

function validDate(value) {
  if (typeof value !== 'string' || !/^\d{4}-\d{2}-\d{2}$/.test(value)) return false;
  const [year, month, day] = value.split('-').map(Number);
  const date = new Date(year, month - 1, day);
  return isoDate(date) === value;
}

function validatePeriod({ dataInicio, dataFim }) {
  if (!dataInicio || !dataFim) return 'Informe a data inicial e a data final.';
  if (!validDate(dataInicio) || !validDate(dataFim)) return 'Informe datas válidas.';
  if (dataInicio > dataFim) return 'A data inicial não pode ser posterior à data final.';
  return '';
}

function formatFilterDate(value) {
  return validDate(value) ? value.split('-').reverse().join('/') : '';
}

module.exports = { defaultPeriod, validatePeriod, formatFilterDate };